import axios from 'axios';
var StripeModule = {};

StripeModule.install = function(Vue) {
  Vue.prototype.$requestStripePayment = function(paymentId, questionnaire, couponCode, callback, errorHanlder) {
    var accounts = questionnaire.getAllContacts();
    accounts[0]['organizationName'] = questionnaire.getAnswer('organizationName').value;
    axios.post(
      process.env.VUE_APP_AUTH_API + '/stripe_payment',
      {
        token: paymentId, accounts,
        products: { "Symbium Build+": questionnaire.getAnswer('numberOfAccounts').value },
        couponCode,
      }
    ).then(callback).catch(errorHanlder);
  }

  Vue.prototype.$requestBankCountCharge = function(bankAccountInfo, questionnaire, callback, stripeBankSubmitFailed, submitACHFailed) {
    var stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
    var questionnaireObject = questionnaire;
    stripe.createToken('bank_account', bankAccountInfo).then(function(data) {
      if(data.error) {
        stripeBankSubmitFailed(data.error);
        return;
      }

      var params = data.token
      params['accounts'] = questionnaireObject.getAllContacts()
      params['accounts'][0]['organizationName'] = questionnaire.getAnswer('organizationName').value;
      params['products'] = { "Symbium Build+": questionnaireObject.getAnswer('numberOfAccounts').value }
      params['couponCode'] = bankAccountInfo.couponCode
      axios.post(
        process.env.VUE_APP_AUTH_API + '/stripe_bank_payment',
        params
      ).then(callback).catch(submitACHFailed);
    });
  }

  Vue.prototype.$addMoreLicenseCreditCardCharage = function(paymentId, numberOfLicenses, couponCode, callback, errorHanlder) {
    axios({
      method: 'POST',
      url: process.env.VUE_APP_AUTH_API + '/payments/add_more_license',
      params: { token: paymentId, licenses: numberOfLicenses, couponCode },
      withCredentials: true,
    }).then((response) => {
      callback(response)
    }, (error) => {
      errorHanlder(error.response.data)
    });
  }

  Vue.prototype.$renewBuildPlus = function(paymentId, callback, error) {
    axios({
      method: 'POST',
      url: process.env.VUE_APP_AUTH_API + '/organizations/renew_buildplus',
      data: { paymentId },
      withCredentials: true,
    }).then(callback, error)
  }
};

export default StripeModule;
